// extracted by mini-css-extract-plugin
export default {"sheet":"ArmorySheet-m_sheet-NHnRR1Bv"};